export default "__VITE_ASSET__d27d2668__"